import dayjs from "dayjs";
import moment from "moment";
import axiosInstance from "src/helpers/axiosInstance";

export const getGlobalSearch = (props) => (onResponse) => {
  try {
    let base_url = "meta-search/global-search?page=" + props?.page + "&limit=" + props?.limit;
     if (typeof (props?.searchData?.sort_key) !== 'undefined' && props?.searchData?.sort_key !== '' && props?.searchData?.sort_key!==undefined && (typeof (props?.searchData?.sort_order) !== 'undefined' && props?.searchData?.sort_order !== '' && props?.searchData?.sort_order!==undefined )) {
           base_url +=`&sort_order=${props?.searchData?.sort_order}&sort_key=${props?.searchData?.sort_key}` 
        }
    axiosInstance
      .post(base_url, props.datas)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {}
};

export const imageFileViewApi = (props) => (onResponse) => {
  let BASE_URL = "dashboard/image-view-support";
  if (props?.payment_id) {
    BASE_URL = BASE_URL + "?payment_id=" + props?.payment_id;
  } else if (props?.other_id) {
    BASE_URL = BASE_URL + "?other_id=" + props?.other_id;
  } else if (props?.xml_id) {
    BASE_URL = BASE_URL + "?xml_id=" + props?.xml_id;
  } else if (props?.xs_url) {
    BASE_URL = BASE_URL + "?xs_url=" + props?.xs_url;
  }
  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {}
};
export const downloadSnippingimageFileApi = (props) => (onResponse) => {
  let BASE_URL = "dashboard/get-snipping-image";
  BASE_URL = BASE_URL + "?file_path=" + props?.file_path;
  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {}
};

export const downloadImageView = (payment_id,document_type='') => (onResponse) => {
  let BASE_URL = "meta-search/payment-image-view";
  if (payment_id) {
    BASE_URL = BASE_URL + "?payment_id=" + payment_id+ "&&document_type=" + document_type;
  }
  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {}
};
export const downloadSnippingimageFileApi1 = (props) => onResponse => {

    let BASE_URL = 'payment/image-view-support'
    if (props?.file_path) {
        BASE_URL = BASE_URL + '?file_path=' + props?.file_path
    }
    if (props?.is_pp_skinny) {
        BASE_URL = BASE_URL + '&&is_pp_skinny=' + props?.is_pp_skinny
    }
    if (props?.lock_box) {
        BASE_URL = BASE_URL + '&&lock_box=' + props?.lock_box
    }
    if (props?.payment_id) {
        BASE_URL = BASE_URL + '&&payment_id=' + props?.payment_id
    }
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
              onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const downloadSnippingimageFileApi2 = (props) => onResponse => {

    let BASE_URL = 'payment/image-view-support-revarc'
    if (props?.file_path) {
        BASE_URL = BASE_URL + '?file_path=' + props?.file_path+ '&&module=' + props?.module
    }
    if (props?.payment_id) {
        BASE_URL = BASE_URL + '&&payment_id=' + props?.payment_id
    }
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const getCommonHeaderGetAndPost = (data) => (onResponse) => {
  try {
    let base_url = "meta-search/header-meta-search" 
    axiosInstance
      .post(base_url,data)
      
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {
    console.log(error);
    
  }
};
export const generatedFileDownload = (props) => onResponse => {
  let BASE_URL = 'file-monitor/job-monitor/downloads/reprocessed-output'
  if(props.is_file_level==1){
    BASE_URL = 'file-monitor/job-monitor/generated-files-download'
  }
  if (props?.file_path) {
      BASE_URL = BASE_URL + '?file_path=' + props?.file_path
  }
  if (props?.lock_box) {
    BASE_URL = BASE_URL + '&&lock_box=' + props?.lock_box
}
  try {
      axiosInstance.get(BASE_URL)
          .then((response) => {
              onResponse(response);
          })
          .catch((err) => {
              onResponse(err.response);
          });

  } catch (error) {

  }

};

export const downloadSnippingFileApi3 = (props) => onResponse => {

    let BASE_URL = 'payment/logfile-view-support-revarc'
    if (props?.file_path) {
        BASE_URL = BASE_URL + '?file_path=' + props?.file_path+ '&&module=' + props?.module
    }
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }

};
export const downloadImageViewRemitanceUpload = (props) => (onResponse) => {
  let BASE_URL = "payment/remittance-upload-file-view";
  if (props?.id) {
    BASE_URL = BASE_URL + "?id=" + props?.id;
  }
  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};
export const downloadImageViewRemitanceFile = (props) => (onResponse) => {

  let BASE_URL = "payment/remittance-claim-file-view";
  if (props?.id) {
    BASE_URL = BASE_URL + "?payment_id=" + props?.id;
  }
  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};